import React, { useState, useEffect } from 'react';

/* --------------------------------------------------------------------------
   Shown across the top of every page while an administrator is signed in as a
   customer for support.

   The point is that it should be impossible to forget: without a persistent
   marker it is very easy to write a post or disconnect an account while inside
   somebody else's workspace. /me reports `impersonated_by` only when the
   session token carries that claim, so this renders nothing in normal use.
   -------------------------------------------------------------------------- */

function ImpersonationBanner() {
  const [impersonatedBy, setImpersonatedBy] = useState(null);
  const [email, setEmail] = useState('');

  useEffect(() => {
    let cancelled = false;

    fetch('https://api.schedpilot.com/wp-json/api/v1/me', { credentials: 'include' })
      .then(res => (res.ok ? res.json() : null))
      .then(json => {
        if (cancelled || !json?.impersonated_by) return;
        setImpersonatedBy(json.impersonated_by);
        setEmail(json.email || '');
      })
      .catch(() => {/* normal session, or offline — show nothing */});

    return () => { cancelled = true; };
  }, []);

  if (!impersonatedBy) return null;

  return (
    <div
      style={{
        background: '#b91c1c',
        color: '#fff',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        flexWrap: 'wrap',
        fontSize: '0.875rem',
        fontWeight: 600,
        position: 'sticky',
        top: 0,
        zIndex: 2000,
      }}
    >
      <span>
        Support session — you are using SchedPilot as{' '}
        <strong>{email || 'this customer'}</strong>. Anything you do here happens in their account.
      </span>

      <a
        href="https://api.schedpilot.com/?sp_impersonate_exit=1"
        style={{
          background: '#fff',
          color: '#b91c1c',
          padding: '5px 14px',
          borderRadius: 7,
          textDecoration: 'none',
          fontWeight: 700,
          whiteSpace: 'nowrap',
        }}
      >
        Exit support session
      </a>
    </div>
  );
}

export default ImpersonationBanner;
